if (!customElements.get('cc-combined-variants')) {
  customElements.define('cc-combined-variants', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-combined-products]').textContent);
      this.products = this.config.products;
      this.info = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.names = [...new Set(this.products.flatMap(product => product.options.map(option => option.name || option)))];
      this.entries = this.products.flatMap(product => product.variants.map(variant => ({
        product,
        variant,
        values: Object.fromEntries(product.options.map((option, i) => [option.name || option, variant.options[i]]))
      })));
      const requested = new URL(location.href).searchParams.get('cc_variant');
      this.current = this.entries.find(entry => String(entry.variant.id) === requested)
        || this.entries.find(entry => entry.variant.id === this.config.initialId)
        || this.entries.find(entry => entry.variant.available) || this.entries[0];
      this.selects = this.names.map((name, index) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'product-form__input product-form__input--dropdown';
        const label = document.createElement('label');
        label.className = 'form__label';
        label.htmlFor = `cc-combined-${this.dataset.section}-${index}`;
        label.textContent = name;
        const container = document.createElement('div');
        container.className = 'select';
        const select = document.createElement('select');
        select.id = label.htmlFor;
        select.className = 'select__select';
        select.dataset.optionName = name;
        for (const value of new Set(this.entries.map(entry => entry.values[name]).filter(value => value !== undefined))) {
          select.add(new Option(value, value));
        }
        select.value = this.current.values[name] || select.options[0]?.value || '';
        select.addEventListener('change', () => this.selectVariant(name));
        container.append(select);
        wrapper.append(label, container);
        this.querySelector('[data-combined-options]').append(wrapper);
        return select;
      });
      this.applyVariant(false);
      this.form.addEventListener('submit', this.beforeSubmit = () => this.writeId(), true);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.beforeSubmit, true);
      this.ready = false;
    }

    selectVariant(changedName) {
      const values = Object.fromEntries(this.selects.map(select => [select.dataset.optionName, select.value]));
      const matches = entry => this.names.every(name => entry.values[name] === values[name]);
      this.current = this.entries.find(matches);
      if (!this.current) {
        const candidates = this.entries.filter(entry => entry.values[changedName] === values[changedName]);
        this.current = candidates.find(entry => entry.variant.available) || candidates[0];
        if (this.current) this.selects.forEach(select => { select.value = this.current.values[select.dataset.optionName] || ''; });
      }
      this.applyVariant(true);
    }

    writeId() {
      const input = this.form.querySelector('[name="id"]');
      input.value = this.current ? String(this.current.variant.id) : '';
      input.disabled = !this.current?.variant.available;
    }

    applyVariant(updateUrl) {
      const variant = this.current?.variant;
      this.writeId();
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = !variant?.available;
      button.setAttribute('aria-disabled', String(!variant?.available));
      button.querySelector('span').textContent = !variant ? this.config.unavailable : variant.available ? this.config.addToCart : this.config.soldOut;
      this.info.querySelector('product-form')?.handleErrorMessage?.();
      this.querySelector('[data-combined-status]').textContent = variant && !variant.available ? this.config.soldOut : '';
      this.querySelector('[data-selected-variant]').textContent = JSON.stringify(variant || null);
      if (!variant) return;
      this.form.dataset.productId = String(this.current.product.id);
      const format = cents => new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(cents / 100);
      const price = this.info.querySelector('[id^="price-"] .price');
      price?.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
      price?.classList.remove('price--sold-out');
      price?.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(node => { node.textContent = format(variant.price); });
      price?.querySelectorAll('.price__sale .price-item--regular').forEach(node => { node.textContent = variant.compare_at_price ? format(variant.compare_at_price) : ''; });
      this.info.querySelectorAll('pickup-availability').forEach(node => node.fetchAvailability?.(variant.id));
      this.info.querySelectorAll('screen-protector-upsell').forEach(node => {
        const modelName = this.names.find(name => /model|device/i.test(name));
        node.updateForModel?.(this.current.values[modelName]);
      });
      if (updateUrl) {
        const url = new URL(location.href);
        if (this.current.product.id === this.products[0].id) {
          url.searchParams.set('variant', String(variant.id));
          url.searchParams.delete('cc_variant');
        } else {
          url.searchParams.delete('variant');
          url.searchParams.set('cc_variant', String(variant.id));
        }
        history.replaceState({}, '', url);
      }
    }
  });
}
